module.exports = __webpack_public_path__ + "img/orange_119.7aacc6b9.png";